(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3445);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CardImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2125);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7966);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;  \n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 1.8rem 2rem;\n  border-radius: 20px;\n  background: ",
        ";\n  text-decoration: none;\n  color: inherit;\n\n  > *:last-child {\n    margin-top: auto;\n  }\n\n  @media ( max-width: 350px ) {\n    padding: 1rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n\n    > a {\n      flex-grow: 1;\n      ",
        "\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      height: 150px;\n\n      img {\n        max-height: 100%;\n        width: auto;\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      flex-grow: 1;\n      min-height: 150px;\n      max-width: 150px;\n\n      img {\n        max-width: 100%;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    h3 {\n      max-width: 27rem;\n      margin: 1.5rem 0 0.5rem;\n      ",
        "\n      font-size: ",
        ";\n      line-height: 1.15;\n    }\n    \n    p {\n      max-width: 27rem;\n      margin: 0 0 1rem;\n      ",
        "\n      font-size: ",
        ";\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    h3 {\n      max-width: 27rem;\n      margin: 0 0 1.5rem;\n      ",
        "\n      font-size: ",
        ";\n    }\n    \n    p {\n      max-width: 27rem;\n      margin: 0;\n      ",
        "\n      font-size: ",
        ";\n    }\n\n    > a {\n      transition:\n        background .3s ease-out,\n        color .3s ease-out;\n      \n      img {\n        filter: invert( 0 );\n        transition: filter .3s ease-out;\n      }\n\n      &:hover {\n        background: ",
        ";\n        color: ",
        ";\n\n        img {\n          filter: invert( 0.9 );\n        }\n      }\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        " {\n    ",
        "\n    \n    ",
        "\n  }\n\n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



function Card(param) {
    var _href = param.href, href = _href === void 0 ? null : _href, _large = param.large, large = _large === void 0 ? false : _large, children = param.children;
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCard, {
            $large: large,
            $asLink: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                href: href,
                children: children
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCard, {
        $large: large,
        children: children
    });
}
var CardImage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d22a2665-0"
})(_templateObject());
var cardWrapStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), function(p) {
    return p.theme.colors.orange;
});
var StyledCard = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d22a2665-1"
})(_templateObject7(), function(p) {
    return !p.$asLink && cardWrapStyles;
}, function(p) {
    return p.$asLink && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), cardWrapStyles);
}, CardImage, function(p) {
    return p.$large && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3());
}, function(p) {
    return !p.$large && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4());
}, function(p) {
    return p.$large && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), p.theme.typo.sentientMedium, p.theme.typo.sizes.large, p.theme.typo.sentientLight, p.theme.typo.sizes.medium);
}, function(p) {
    return !p.$large && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), p.theme.typo.sentientLight, p.theme.typo.sizes.bumped, p.theme.typo.sentientMedium, p.theme.typo.sizes.bumped, p.theme.colors.black, p.theme.colors.ivory);
});
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 1849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2125);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SectionHeading = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-92e95595-0"
})(_templateObject(), function(p) {
    return p.theme.typo.sizes.normal;
});
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeading);


/***/ }),

/***/ 2646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ StyledTinyCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2125);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7966);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  background: ",
        ";\n  border-radius: 20px;\n  box-shadow: inset 0 0 0 1px ",
        ";\n  color: inherit;\n  text-decoration: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n\n    > a {\n      flex-grow: 1;\n      ",
        "\n      transition: \n        background .3s ease-out,\n        color .3s ease-out;\n\n      &:hover {\n        background: ",
        ";\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n\n  p:first-child {\n    margin: 0;\n    padding: 1rem 1.2rem;\n    font-weight: 600;\n    font-size: ",
        ";\n    border-bottom: 1px solid ",
        ";\n  }\n\n  h3 {\n    margin: 0;\n    padding: 1.2rem;\n    ",
        ";\n    font-size: ",
        ";\n    line-height: 1.15;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



function TinyCard(param) {
    var _href = param.href, href = _href === void 0 ? null : _href, _icon = param.icon, icon = _icon === void 0 ? null : _icon, type = param.type, title = param.title;
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTinyCard, {
            $asLink: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TinyCardContent, {
                    icon: icon,
                    type: type,
                    title: title
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTinyCard, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TinyCardContent, {
            icon: icon,
            type: type,
            title: title
        })
    });
}
function TinyCardContent(param) {
    var type = param.type, title = param.title, _icon = param.icon, icon = _icon === void 0 ? null : _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    icon,
                    type
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: title
            })
        ]
    });
}
var cardWrapStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), function(p) {
    return p.theme.colors.ivory;
}, function(p) {
    return p.theme.colors.warmLightGrey;
});
var StyledTinyCard = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cf0132bb-0"
})(_templateObject2(), function(p) {
    return !p.$asLink && cardWrapStyles;
}, function(p) {
    return p.$asLink && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), cardWrapStyles, p.theme.colors.black, p.theme.colors.white);
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.colors.warmLightGrey;
}, function(p) {
    return p.theme.typo.sentientLight;
}, function(p) {
    return p.theme.typo.sizes.bumped;
});
/* harmony default export */ __webpack_exports__["Z"] = (TinyCard);


/***/ }),

/***/ 3445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/AppChrome.tsx + 22 modules
var AppChrome = __webpack_require__(5368);
// EXTERNAL MODULE: ./components/Hero.tsx
var Hero = __webpack_require__(1547);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(9851);
// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(5988);
// EXTERNAL MODULE: ./components/ContentBlocks.tsx + 1 modules
var ContentBlocks = __webpack_require__(2393);
;// CONCATENATED MODULE: ./components/HomepageContent.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  overflow: hidden;\n  flex: 0 0 115%;\n  margin-left: -15%;\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n\n  @media ( max-width: ",
        "px ) {\n    padding-bottom: 65%;\n    margin-bottom: 2rem;\n  }\n  \n  @media ( min-width: ",
        "px ) {\n    flex: 0 0 calc( 62% - calc( var( --grid-gutter ) / 2 ) );\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 100%;\n  margin-left: auto;\n  \n  @media ( min-width: ",
        "px ) {\n    flex: 0 0 calc( 50% - calc( var( --grid-gutter ) / 2 ) );\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





function HomapageContent(param) {
    var image = param.image, contentBlocks = param.contentBlocks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHomepageContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: image.url,
                        alt: image.alt,
                        layout: "fill",
                        objectFit: "cover",
                        sizes: "(min-width: 850px) 50vw, 100vw",
                        dateModified: image.dateModified,
                        priority: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContentBlocks, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBlocks/* default */.Z, {
                        contentBlocks: contentBlocks
                    })
                })
            ]
        })
    });
}
var breakpoint = 850;
var StyledHomepageContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-993d5f4b-0"
})(_templateObject());
var StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-993d5f4b-1"
})(_templateObject1(), breakpoint - 1, breakpoint);
var StyledContentBlocks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-993d5f4b-2"
})(_templateObject2(), breakpoint);
/* harmony default export */ var HomepageContent = (HomapageContent);

// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(5076);
// EXTERNAL MODULE: ./components/SectionHeading.tsx
var SectionHeading = __webpack_require__(1849);
// EXTERNAL MODULE: ./components/Card.tsx
var Card = __webpack_require__(6050);
// EXTERNAL MODULE: ./components/ButtonLink.tsx + 1 modules
var ButtonLink = __webpack_require__(622);
;// CONCATENATED MODULE: ./components/DiscoverTheCourse.tsx
function DiscoverTheCourse_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DiscoverTheCourse_templateObject() {
    var data = DiscoverTheCourse_taggedTemplateLiteral([
        "\n  display: grid;\n  margin: calc( var( --grid-gutter ) / -2 );\n\n  > * {\n    margin: calc( var( --grid-gutter ) / 2 );\n  }\n\n  @media ( min-width: 650px ) {\n    grid-template-columns: 1fr 1fr;\n  }\n"
    ]);
    DiscoverTheCourse_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function DiscoverTheCourse() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            $top: 2.5,
            $between: 1.5,
            $responsive: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading/* default */.Z, {
                    children: "Discover the course"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                large: true,
                                href: "/course/what-is-energy",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* CardImage */.x, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "https://d1bpb8miavkgm5.cloudfront.net/icons/house-icon.gif",
                                            alt: "",
                                            width: 981,
                                            height: 688,
                                            layout: "raw",
                                            sizes: "(min-width: 600px) 300px, 80vw"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Start at the beginning"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "If you\u2019re a beginner, work your way through the course step-by-step, starting from the introduction."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                        children: "Begin"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                large: true,
                                href: "/course",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* CardImage */.x, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "https://d1bpb8miavkgm5.cloudfront.net/icons/magifying-glass-icon.gif",
                                            alt: "",
                                            width: 1007,
                                            height: 746,
                                            layout: "raw",
                                            sizes: "(min-width: 600px) 300px, 80vw"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Start exploring"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "If you already have some knowledge of the subject you can explore all of the topics available."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                        children: "Explore"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d80869ff-0"
})(DiscoverTheCourse_templateObject());
/* harmony default export */ var components_DiscoverTheCourse = (DiscoverTheCourse);

// EXTERNAL MODULE: ./lib/craft/index.tsx + 2 modules
var craft = __webpack_require__(2678);
// EXTERNAL MODULE: ./components/TinyCard.tsx
var TinyCard = __webpack_require__(2646);
;// CONCATENATED MODULE: ./components/FeaturedContent.tsx
function FeaturedContent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FeaturedContent_templateObject() {
    var data = FeaturedContent_taggedTemplateLiteral([
        "\n  display: grid;\n  margin: calc( var( --grid-gutter ) / -2 );\n\n  > * {\n    margin: calc( var( --grid-gutter ) / 2 );\n  }\n\n  @media ( min-width: 650px ) {\n    grid-template-columns: repeat( 3, 1fr );\n  }\n"
    ]);
    FeaturedContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function FeaturedContent(param) {
    var content = param.content;
    var ref = (0,craft/* useCraft */.Yi)(), sessions = ref.pageProps.sessions;
    var cards = cardsFromContent(content, sessions);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            $top: 4,
            $between: 1.5,
            $bottom: 5,
            $responsive: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading/* default */.Z, {
                    children: "Featured content"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedContent_StyledGrid, {
                    children: cards.map(function(card) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TinyCard/* default */.Z, {
                            href: card.href,
                            type: card.type,
                            title: card.title
                        }, card.id);
                    })
                })
            ]
        })
    });
}
var cardsFromContent = function(content, sessions) {
    return content.map(function(entry) {
        return {
            id: entry.id,
            type: typeFromEntry(entry),
            title: entry.title,
            href: hrefFromEntry(entry, sessions)
        };
    });
};
var typeFromEntry = function(entry) {
    if (entry.sectionHandle === "chunks") {
        var ref;
        return entry.chunkType.length > 0 && ((ref = entry.chunkType[0]) === null || ref === void 0 ? void 0 : ref.title);
    }
    if (entry.sectionHandle === "sessions") {
        return "Session ".concat(entry.lft / 2);
    }
    return "Info";
};
var hrefFromEntry = function(entry, sessions) {
    if (entry.sectionHandle === "chunks") {
        var firstRelatedSession = sessions.find(function(s) {
            return s.chunks.find(function(c) {
                return c.id === entry.id;
            });
        });
        var queryString = firstRelatedSession ? "?sessionId=".concat(firstRelatedSession.id) : "";
        return "".concat(entry.url.replace("https://".concat("mpowerlearn.co.uk"), "")).concat(queryString);
    }
    return entry.url.replace("https://".concat("mpowerlearn.co.uk"), "");
};
var FeaturedContent_StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ad8cbd0-0"
})(FeaturedContent_templateObject());
/* harmony default export */ var components_FeaturedContent = (FeaturedContent);

;// CONCATENATED MODULE: ./pages/index.tsx






function Home(param) {
    var homepage = param.entry;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppChrome/* default */.Z, {
        withShapes: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                children: homepage.pageIntro
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageContent, {
                image: homepage.mainImage[0],
                contentBlocks: homepage.contentBlocks
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DiscoverTheCourse, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeaturedContent, {
                content: homepage.featuredContent
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);